import { useAuth } from 'react-oidc-context';
import { useDispatch } from 'react-redux';
import { useDeepCompareEffect } from 'react-use';

import { useLoginStore } from '@savgroup-front-common/core/domains/login/useLoginStore';

import { signIn } from '@/domains/login/actions';

import Layout from '../layout/Layout';

import LoadingScreen from './LoadingScreen';

const CheckAuthorized = () => {
  const auth = useAuth();
  const dispatch = useDispatch();
  const setLoginStore = useLoginStore((state) => state.setLoginStore);

  const { isAuthenticated, isLoading, error, activeNavigator, user } = auth;

  useDeepCompareEffect(() => {
    if (user && isAuthenticated) {
      dispatch(signIn({ onLogin: () => undefined, setLoginStore }) as any);

      return;
    }
  }, [dispatch, isAuthenticated, user, setLoginStore]);

  switch (activeNavigator) {
    case 'signinSilent':
      return <LoadingScreen notifications={[]} />;
    case 'signoutRedirect':
      return <LoadingScreen notifications={[]} />;
  }

  if (isLoading) {
    return <LoadingScreen notifications={[]} />;
  }

  if (error) {
    throw new Error(error.message);
  }

  if (isAuthenticated) {
    return <Layout />;
  }

  auth.signinRedirect();

  return <LoadingScreen notifications={[]} />;
};

export default CheckAuthorized;
